import { Middleware } from "redux";
import { RootState } from "../../../state";
import {
  CALL_METHOD,
  setUIError,
  startUILoading,
  stopUILoading,
} from "../../../actions";

export const callMethod: Middleware<unknown, RootState> =
  ({ dispatch, getState }) =>
  (next) =>
  async (action) => {
    next(action);
    if (action.type === CALL_METHOD.START) {
      const { functionName, contractName, args, options } = action.meta;
      const { key, onFinish, onError, callKey } = options ?? {};
      const Key = key ?? functionName;
      try {
        dispatch(startUILoading(Key));
        const {
          contract: { contracts },
        } = getState();
        const currentContract = contracts[contractName];
        const response = await currentContract.methods[functionName](
          ...args
        ).call();
        const data: any = {
          [callKey ?? functionName]: response,
        };
        dispatch({
          type: CALL_METHOD.SUCCESS,
          payload: { contractName, data },
        });
        onFinish?.(response);
        dispatch(stopUILoading(Key));
      } catch (e) {
        console.log(`OUTPUT ${contractName} - ${functionName} ::::`, args, e);
        dispatch(stopUILoading(Key));
        dispatch(setUIError(Key, e as string));
        onError?.(e);
        dispatch({ type: CALL_METHOD.ERROR, e });
      }
    }
  };
